import { createSlice } from '../../../canvas/core';
import * as updaters from './state-updaters';
import type { PageLayoutDeps, PageLayoutSlice, PageState } from './types';

const DEFAULT_PAGE_STATE: Omit<PageState, 'dimensions'> = {
  visible: false,
};

const FALLBACK_PAGE_STATE: PageState = {
  dimensions: { width: 0, height: 0 },
  ...DEFAULT_PAGE_STATE,
};

export const pageLayoutSlice = createSlice<PageLayoutDeps>()<PageLayoutSlice>(
  (set, get, _api) => ({
    pageLayout: {
      list: {},
      order: [],
      activeId: null,

      selectors: {
        getPageState: pageId => {
          const state = get().pageLayout.list[pageId];

          return state ?? FALLBACK_PAGE_STATE;
        },
      },

      actions: {
        initializePage: (pageId, dimensions, initialState = {}) => {
          set(updaters.initializePage(pageId, dimensions, initialState));
        },

        setPageDimensions: (pageId, dimensions) => {
          set(updaters.setPageDimensions(pageId, dimensions));
        },

        setPageVisible: (pageId, visible) => {
          set(updaters.setPageVisible(pageId, visible));
        },

        setActivePage: pageId => {
          set(updaters.setActivePage(pageId));
        },

        setPageOrder: pageOrder => {
          set(updaters.setPageOrder(pageOrder));
        },
      },
    },
  })
);
